
// routes
import { PATH_COEAdmin, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    noneligibleRecords: icon('ic_noneligible'),
    enablereupload: icon('ic_reupload'),
    dealerrequest: icon('ic_request'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    reprocess: icon('ic_reprocess'),
    raiseticket: icon('ic_raiseticket'),
    helpdesk: icon('communication'),
    data: icon('ic_data'),
};
// const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;

const userRole = AppCache?.GetCurrentLoggedInUser()?.UserRoleName;

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [

    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            { title: 'Data Upload Status', path: PATH_COEAdmin.dataUploadApprove, icon: ICONS.dataUpload },
            ...(hasZylemFranchise ? [
                { title: 'Reload Zylem Data', path: PATH_COEAdmin.reloadzylemdata, icon: ICONS.reprocess },
                { title: 'Data Mapping', path: PATH_COEAdmin.datamapping, icon: ICONS.dataMapping }
            ] : []),
            { title: 'Enable Reupload', path: PATH_COEAdmin.enablereupload, icon: ICONS.enablereupload },
            { title: 'Configuration', path: PATH_COEAdmin.configuration, icon: ICONS.master, },
            // { title: 'System Configuration ', path: PATH_COEAdmin.cutoffdatepage, icon: ICONS.master },
            { title: 'System Configuration ', path: PATH_COEAdmin.franchisewisecutoff, icon: ICONS.master },
            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            {
                title: 'Masters', path: PATH_COEAdmin.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_COEAdmin.master.distributor },
                    { title: 'Products', path: PATH_COEAdmin.master.product },
                    { title: 'ECP Product', path: PATH_COEAdmin.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_COEAdmin.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_COEAdmin.master.account },
                    { title: 'Area Tree', path: PATH_COEAdmin.master.areatree },
                    { title: 'Surgeons', path: PATH_COEAdmin.master.surgeon },
                    { title: 'Employee', path: PATH_COEAdmin.master.empmaster },
                    { title: 'Territory', path: PATH_COEAdmin.master.territory },
                    { title: 'Employee Territory', path: PATH_COEAdmin.master.empterritory },
                    { title: 'Territory Management', path: PATH_COEAdmin.master.accountterritory },
                    { title: 'Branch Secretary Region', path: PATH_COEAdmin.master.empregion },
                    { title: 'Distributor Territory', path: PATH_COEAdmin.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_COEAdmin.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_COEAdmin.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_COEAdmin.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_COEAdmin.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_COEAdmin.master.distributorbillingsoftware },
                    { title: 'Customer', path: PATH_COEAdmin.master.customers },
                    { title: 'Customer Account', path: PATH_COEAdmin.master.customeraccount },
                ],
            },
            {
                title: 'Allied Master', path: PATH_COEAdmin.alliedmaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor Group', path: PATH_COEAdmin.alliedmaster.distributorgroup },
                    { title: 'UOM', path: PATH_COEAdmin.alliedmaster.uom },
                    { title: 'Franchise', path: PATH_COEAdmin.alliedmaster.franchise },
                    { title: 'Sub Franchise', path: PATH_COEAdmin.alliedmaster.subfranchise },
                    { title: 'Product Group', path: PATH_COEAdmin.alliedmaster.productgroup },
                    { title: 'Product category', path: PATH_COEAdmin.alliedmaster.productcategory },
                    { title: 'Product Brand', path: PATH_COEAdmin.alliedmaster.productbrand },
                    { title: 'Product Line', path: PATH_COEAdmin.alliedmaster.productline },
                    { title: 'Account Group', path: PATH_COEAdmin.alliedmaster.accountgroup },
                    { title: 'Account Type', path: PATH_COEAdmin.alliedmaster.accounttype },
                    { title: 'Account Classification', path: PATH_COEAdmin.alliedmaster.accountclassification },
                    { title: 'Account Segmentation', path: PATH_COEAdmin.alliedmaster.accountsegmentation },
                    { title: 'Account Category', path: PATH_COEAdmin.alliedmaster.accountcategory },
                    { title: 'Surgeon Contact Type', path: PATH_COEAdmin.alliedmaster.surgeoncontacttype },
                    { title: 'Surgeon Sub Contact Type', path: PATH_COEAdmin.alliedmaster.surgeonsubcontacttype },
                    { title: 'City Tier', path: PATH_COEAdmin.alliedmaster.citytier },
                    { title: 'Employee Level', path: PATH_COEAdmin.alliedmaster.emplevel },
                    { title: 'Specialist', path: PATH_COEAdmin.alliedmaster.specialist },
                    { title: 'Bravo Hierarchy', path: PATH_COEAdmin.alliedmaster.bravohierarchy },
                ],
            },
            {
                title: 'Data', path: PATH_COEAdmin.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_COEAdmin.data.inventorypage },
                ],
            },
            {
                title: 'Report', path: PATH_COEAdmin.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_COEAdmin.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_COEAdmin.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_COEAdmin.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_COEAdmin.report.dealerreportpage },
                    { title: 'Dump Report', path: PATH_COEAdmin.report.territorydumpreportpage },
                    { title: 'Dealer Purchase Report', path: PATH_COEAdmin.report.dealerpurchasereportpage },
                    { title: 'Activity Log', path: PATH_COEAdmin.report.activitylogpage },
                    { title: 'Inventory Report', path: PATH_COEAdmin.report.inventoryreportpage },
                    ...(userRole !== 'COE Viewer'
                        ? [
                            { title: 'Standard Price Report', path: PATH_COEAdmin.report.standardpricereportpage },
                            //  { title: 'Module Role Access List', path: PATH_COEAdmin.report.moduleroleaccesslistpage },
                        ] : []
                    ),
                    { title: 'Request Report', path: PATH_COEAdmin.report.ytddumpreportpage },
                ],
            },
        ],
    }
];

export default navConfig;